import Follow from './Follow';

export default Follow;
